export const GET_OFFICIAL_FRAMES = "GET_OFFICIAL_FRAMES";
export const CREATE_OFFICIAL_FRAME = "CREATE_OFFICIAL_FRAME";
export const UPDATE_OFFICIAL_FRAME = "UPDATE_OFFICIAL_FRAME";
export const DELETE_OFFICIAL_FRAME = "DELETE_OFFICIAL_FRAME";

export const OPEN_DIALOGUE_OFFICIAL_FRAME = "OPEN_DIALOGUE_OFFICIAL_FRAME";
export const CLOSE_DIALOGUE_OFFICIAL_FRAME = "CLOSE_DIALOGUE_OFFICIAL_FRAME";

export const OPEN_GIVE_OFFICIAL_FRAME_DIALOGUE = "OPEN_GIVE_OFFICIAL_FRAME_DIALOGUE";
export const CLOSE_GIVE_OFFICIAL_FRAME_DIALOGUE = "CLOSE_GIVE_OFFICIAL_FRAME_DIALOGUE";
